import type {
	PendingCutsMethod,
	PendingCutsReportParams,
} from '../../../../redux/api/pending-cuts';

export const METHODS: PendingCutsMethod[] = ['fastlane', 'swiss', 'both'];

export const METHOD_LABELS: Record<PendingCutsMethod, string> = {
	fastlane: 'Fastlane',
	swiss: 'Swiss',
	both: 'Both',
};

export interface PendingCutsFilters {
	method: PendingCutsMethod;
	buildings: string[];
	bar: string;
}

const list = (value: string | null) =>
	value
		? value
				.split(',')
				.map((v) => v.trim())
				.filter(Boolean)
		: [];

export const filtersFromSearchParams = (
	params: URLSearchParams
): PendingCutsFilters => {
	const method = params.get('method') as PendingCutsMethod | null;
	return {
		method: method && METHODS.includes(method) ? method : 'fastlane',
		buildings: list(params.get('buildings')),
		bar: params.get('bar') ?? '',
	};
};

export const filtersToSearchParams = (
	filters: PendingCutsFilters
): URLSearchParams => {
	const params = new URLSearchParams({ method: filters.method });
	if (filters.buildings.length)
		params.set('buildings', filters.buildings.join(','));
	if (filters.bar.trim()) params.set('bar', filters.bar.trim());
	return params;
};

export const toReportParams = (
	filters: PendingCutsFilters
): PendingCutsReportParams => ({
	method: filters.method,
	building_ids: filters.buildings,
	bar: filters.bar,
});
